var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95092 5.40845L2.23425 0.700112C2.15679 0.622005 2.06462 0.56001 1.96307 0.517703C1.86152 0.475395 1.7526 0.453613 1.64259 0.453613C1.53258 0.453613 1.42366 0.475395 1.32211 0.517703C1.22056 0.56001 1.12839 0.622005 1.05092 0.700112C0.895712 0.856247 0.808594 1.06746 0.808594 1.28761C0.808594 1.50777 0.895712 1.71898 1.05092 1.87511L5.17592 6.04178L1.05092 10.1668C0.895712 10.3229 0.808594 10.5341 0.808594 10.7543C0.808594 10.9744 0.895712 11.1856 1.05092 11.3418C1.1281 11.4205 1.22014 11.4832 1.3217 11.5261C1.42326 11.569 1.53233 11.5913 1.64259 11.5918C1.75284 11.5913 1.86191 11.569 1.96348 11.5261C2.06504 11.4832 2.15708 11.4205 2.23425 11.3418L6.95092 6.63345C7.03551 6.55541 7.10302 6.4607 7.14919 6.35528C7.19536 6.24987 7.2192 6.13603 7.2192 6.02095C7.2192 5.90586 7.19536 5.79202 7.14919 5.68661C7.10302 5.58119 7.03551 5.48648 6.95092 5.40845Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRightIcon);
export default __webpack_public_path__ + "static/media/angle-right-icon.ca4efe9288d96a99d20217bcedf9e2be.svg";
export { ForwardRef as ReactComponent };